import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { IBannerProduct, BannerProduct } from 'app/constants/schemas/BannerProduct';
import { BrandReference, IBrandReference } from './BrandReference';

export interface IBannerContext extends IEntity {
  attributes: {
    id: EntityStringId;
    name: string | null;
    services: string[];
    studyLanguages: string[];
  };
  associations: {
    bannerProducts: IBannerProduct[];
    brands: IBrandReference[];
  };
}

export type BannerContext = Entity<IBannerContext>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BannerContext: IEntityType<IBannerContext> = vmClient.defineClass({
  typeName: 'BannerContext',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    name: {
      type: 'string',
    },
    services: {
      type: 'string',
      collection: true,
      notNull: true,
    },
    studyLanguages: {
      type: 'string',
      collection: true,
      notNull: true,
    },
  },
  associations: {
    bannerProducts: {
      type: BannerProduct,
      collection: true,
      notNull: true,
    },
    brands: {
      type: BrandReference,
      notNull: true,
      collection: true,
      shared: true,
    },
  },
});
